import { render, staticRenderFns } from "./checkPassCard.vue?vue&type=template&id=3bea4b3f&scoped=true&"
import script from "./checkPassCard.vue?vue&type=script&lang=js&"
export * from "./checkPassCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bea4b3f",
  null
  
)

export default component.exports